import type { Notification } from "@circle-react/types/Notification";
import { Typography } from "@circleco/compass/components/Typography";

import { Typography as UiKitTypography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

export interface NotifiableTitleProps {
  notification: Notification;
}

export const NotifiableTitle = ({ notification }: NotifiableTitleProps) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <Typography variant="label-sm">
        {notification.notifiable_title}
      </Typography>
    );
  }

  return (
    <UiKitTypography.BodySm as="span" weight="font-semibold">
      {notification.notifiable_title}
    </UiKitTypography.BodySm>
  );
};
